<a mat-list-item (click)="toggle()" style="width: fit-content;">
        <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}"
            class="submenu">
            <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Tabelas de Referência">
                <mat-icon>table_chart</mat-icon>
                <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Tabelas de Referência</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="start stretch">
                <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
            </div>
        </div>
    </a>

    <mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

        <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

            <!-- EIXOS -->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().EIXO)" icone="toc" titulo="Eixo" rota="eixo" toolTip="Eixo"></sub-menu>
            </div>

            <!-- PLANOS DE CONTAS-->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().TIPO_REUNIAO)" icone="toc" titulo="Tipo de Reunião" rota="tiposreunioes" toolTip="Tipo de Reunião"></sub-menu>
            </div>
        
            <!-- PUBLICOS_ALVOS -->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().PUBLICOS_ALVOS)" icone="toc" titulo="Públicos Alvos" rota="publicosalvos" toolTip="Públicos Alvos"></sub-menu>
            </div>
        </div>
    </mat-nav-list>
